import type React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import type { ContentsProps } from "../../types";

const CustomerAnalytics: React.FC<ContentsProps> = ({ data, isLoading }) => {
  if (isLoading) {
    return <div>Loading...</div>;
  }

  // Calculate total to ensure percentages add up to 100%
  const totalCategories =
    data?.customer_analytics.totals.category_a_percentage +
    data?.customer_analytics.totals.category_b_percentage +
    data?.customer_analytics.totals.category_c_percentage;

  // Adjust the last category if needed to make sure it sums to 100%
  const categoryAPercentage =
    data?.customer_analytics.totals.category_a_percentage.toFixed(2);
  const categoryBPercentage =
    data?.customer_analytics.totals.category_b_percentage.toFixed(2);

  // Calculate the third percentage to ensure the sum is exactly 100%
  const categoryCPercentage = (
    100 -
    parseFloat(categoryAPercentage) -
    parseFloat(categoryBPercentage)
  ).toFixed(2);

  return (
    <div className="w-full space-y-6 p-4">
      <h2 className="text-xl font-semibold">Customer Analytics</h2>
      <div className="h-96 w-full">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data?.customer_analytics.monthly_data}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month_name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="category_a_count" name="Category A" fill="#8884d8" />
            <Bar dataKey="category_b_count" name="Category B" fill="#82ca9d" />
            <Bar dataKey="category_c_count" name="Category C" fill="#ffc658" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* <div className="space-y-4"> */}
      {/* <h3 className="text-lg font-semibold">Total Statistics</h3> */}
      {/* <div className="grid grid-cols-1 gap-4 md:grid-cols-2"> */}
      {/* <div className="rounded-lg border bg-white p-6 shadow-sm"> */}
      {/* <h4 className="mb-2 text-sm font-medium text-gray-600">
              Total Customers
            </h4> */}
      {/* <p className="text-2xl font-bold text-gray-900">
              {data?.customer_analytics.totals.total_customers.toLocaleString()}
            </p> */}
      {/* </div> */}
      {/* <div className="rounded-lg border bg-white p-6 shadow-sm">
            <h4 className="mb-4 text-sm font-medium text-gray-600">
              Category Distribution
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center justify-between">
                <span className="text-gray-600">Category A:</span>
                <span className="font-medium text-gray-900">
                  {categoryAPercentage}%
                </span>
              </li>
              <li className="flex items-center justify-between">
                <span className="text-gray-600">Category B:</span>
                <span className="font-medium text-gray-900">
                  {categoryBPercentage}%
                </span>
              </li>
              <li className="flex items-center justify-between">
                <span className="text-gray-600">Category C:</span>
                <span className="font-medium text-gray-900">
                  {categoryCPercentage}%
                </span>
              </li>
            </ul>
          </div> */}
      {/* </div> */}
      {/* </div> */}
    </div>
  );
};

export default CustomerAnalytics;
